import React from 'react';
import TicketItem from './TicketItem';

const TicketsList = ({ tickets, pagination, onPageChange }) => {
  if (!tickets || tickets.length === 0) {
    return (
      <div className="tickets-empty-state text-center p-5">
        <p>No tickets found</p>
      </div>
    );
  }

  return (
    <div className="tickets-container">
      <div className="tickets-list px-3 pb-3">
        {tickets.map(ticket => (
          <TicketItem key={ticket.billId} ticket={ticket}/>
        ))}
      </div>
      
      {pagination.totalPage > 1 && (
        <div className="pagination-container d-flex justify-content-center align-items-center py-3">
          <button 
            className="btn btn-outline-primary mx-1"
            onClick={() => onPageChange(pagination.page - 1)}
            disabled={pagination.page === 1}
          >
            Previous
          </button>
          
          <span className="mx-3">
            Page {pagination.page} of {pagination.totalPage}
          </span>
          
          <button 
            className="btn btn-outline-primary mx-1"
            onClick={() => onPageChange(pagination.page + 1)}
            disabled={pagination.page === pagination.totalPage}
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default TicketsList;